export default __webpack_public_path__ + "static/h08-ef7742f65d875d1f6f3c669826eea5fc.png";